import React from "react";
import { Checkbox } from "@mui/material";

const VendorSelectionCard = ({ vendor, onToggle }) => {
  return (
    <div
      className={`vendor-selection-card ${vendor.selected ? "selected" : ""}`}
      onClick={() => onToggle(vendor.id)}
    >
      <Checkbox
        value={vendor.id}
        checked={vendor.selected}
        onChange={() => {}}
        sx={{
          color: "#02060C",
          "&.Mui-checked": {
            color: "#FF5200",
          },
        }}
      />
      <div className="vendor-name">
        <span>{vendor.name}</span>
      </div>
      <p className="price">
        {/* Starting from <strong>{vendor.price}</strong>
        <span>/piece</span> */}
        <span>Request for Pricing</span>
      </p>
    </div>
  );
};

export default VendorSelectionCard;
